import React, { useState } from "react";
import Select from "react-select";
import * as Components from "../../../components/all";

import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { Slide } from "pure-react-carousel";
import { HiOfficeBuilding } from "react-icons/hi";

export default function Revenue() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Select Tag Types
	const [revenueType, setRevenueType] = useState("all-time");
	const [trendType, setTrendType] = useState("all-time");

	// Revenue Data
	var revenueData = {
		allTimeRevenue: [
			{
				year: "2015",
				revenue: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			},
			{
				year: "2016",
				revenue: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
			},
			{
				year: "2017",
				revenue: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 650],
			},
			{
				year: "2018",
				revenue: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			},
			{
				year: "2019",
				revenue: [1200, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
			},
			{
				year: "2020",
				revenue: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 650],
			},
			{
				year: "2021",
				revenue: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			},
			{
				year: "2022",
				revenue: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
			},
			{
				year: "2023",
				revenue: [500, 1000, 2000, 2500, 30, 35, 40, 40, 500, 550, 600, 500],
			},
		],
		cityRevenue: [
			{ city: "Islamabad", revenue: [5, 219, 39, 28, 0, 265] },
			{ city: "Lahore", revenue: [55, 29, 39, 128, 0, 135] },
			{ city: "Karachi", revenue: [55, 29, 39, 28, 0, 145] },
			{ city: "Rawalpindi", revenue: [15, 29, 39, 0, 48, 340] },
			{ city: "Gujrat", revenue: [55, 291, 39, 28, 0, 125] },
		],
		top3ParkingSpaces: [
			{
				ps: "Comsats University Islamabad, Islamabad",
				revenue: 671980,
			},
			{
				ps: "Government College, Lahore",
				revenue: 601980,
			},
			{
				ps: "Quaid-e-Azam University, Islamabad",
				revenue: 561980,
			},
		],
	};

	// settings
	var settings = {
		selectStyles: {
			control: (provided, state) => ({
				...provided,
				minHeight: "30px",
				height: "30px",
				boxShadow: state.isFocused ? null : null,
			}),

			valueContainer: (provided, state) => ({
				...provided,
				height: "30px",
				padding: "0 8px 0 8px",
			}),

			input: (provided, state) => ({
				...provided,
				margin: "0px",
			}),

			indicatorSeparator: (state) => ({
				display: "none",
			}),

			indicatorsContainer: (provided, state) => ({
				...provided,
				height: "30px",
			}),
		},
		yearlyTrendGraph: {
			options: {
				chart: {
					type: "area",
					stacked: false,
					height: "90%",
					zoom: {
						type: "x",
						enabled: true,
						autoScaleYaxis: true,
					},
					toolbar: {
						autoSelected: "zoom",
						tools: {
							download: true,
							selection: false,
							zoom: false,
							zoomin: true,
							zoomout: true,
							pan: false,
							reset: true,
						},
					},
				},
				dataLabels: {
					enabled: false,
				},
				legend: {
					show: false,
				},
				markers: {
					size: 4,
					colors: undefined,
					strokeColors: "#fff",
					strokeWidth: 0,
					fillOpacity: 1,
					discrete: [],
					shape: "circle",
					showNullDataPoints: true,
					hover: {
						sizeOffset: 3,
					},
				},
				fill: {
					type: "gradient",
					gradient: {
						shadeIntensity: 1,
						inverseColors: false,
						opacityFrom: 0.5,
						opacityTo: 0.2,
						stops: [10, 100],
					},
				},
				yaxis: {
					labels: {
						formatter: function (val) {
							return val.toFixed(0) + "k";
						},
					},
				},
				xaxis: {
					categories:
						trendType === "all-time"
							? [
									"2015",
									"2016",
									"2017",
									"2018",
									"2019",
									"2020",
									"2021",
									"2022",
									"2023",
							  ]
							: [
									"Jan",
									"Feb",
									"Mar",
									"Apr",
									"May",
									"Jun",
									"Jul",
									"Aug",
									"Sep",
									"Oct",
									"Nov",
									"Dec",
							  ],
				},
				stroke: {
					curve: "smooth",
					lineCap: "butt",
					width: 2,
					dashArray: 0,
				},
			},
		},
		cityTrendGraph: {
			options: {
				chart: {
					type: "bar",
					stacked: false,
					height: "90%",
					zoom: {
						type: "x",
						enabled: true,
						autoScaleYaxis: true,
					},
					toolbar: {
						autoSelected: "zoom",
						tools: {
							download: false,
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
							reset: false,
						},
					},
				},
				dataLabels: {
					enabled: false,
				},
				legend: {
					show: false,
				},
				markers: {
					size: 0,
				},
				yaxis: {
					labels: {
						formatter: function (val) {
							return val + "k";
						},
					},
				},
				xaxis: {
					categories: revenueData.cityRevenue.map((x) => x.city),
				},
				plotOptions: {
					bar: {
						horizontal: false,
						endingShape: "rounded",
					},
				},
				stroke: {
					show: true,
					width: 8,
					colors: ["transparent"],
				},
			},
			series: [
				{
					name: "Total Revenue",
					data: revenueData.cityRevenue.map((x) =>
						x.revenue.reduce((a, b) => a + b)
					),
				},
				{
					name: "This Year's Revenue",
					data: revenueData.cityRevenue.map((x) => x.revenue.pop()),
				},
			],
		},
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="Revenue
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[220px]
					sm:min-w-[350px] flex-[2]
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							px-2 pb-7 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<div
								className="
									h-6 w-6
									flex items-center justify-center
									rounded-full
									bg-[#fedddd] 
									text-[#FA9499]
									"
							>
								<RiMoneyDollarCircleFill />
							</div>
							<h1 className="ml-2 text-darker">Air Space Revenue</h1>
						</div>

						<Select
							className="text-sm"
							styles={settings.selectStyles}
							options={[
								{ value: "all-time", label: "All Time" },
								{ value: "yearly", label: "Yearly" },
							]}
							defaultValue={{ value: "all-time", label: "All Time" }}
							onChange={(e) => setRevenueType(e.value)}
						/>
					</div>

					{/* data */}
					<div className="my-auto w-full">
						{revenueType === "all-time" ? (
							<div className="w-fit mx-auto">
								<h1 className="text-3xl font-medium tracking-tighter text-center">
									Rs.{" "}
									{revenueData.allTimeRevenue
										.map((x) => x.revenue.reduce((sum, cur) => sum + cur))
										.reduce((a, b) => a + b)
										.toLocaleString()}
								</h1>
								<h2
									className="text-green-400 
											mt-1 
											text-center
											text-lg
											"
								>
									Total Revenue
								</h2>
							</div>
						) : (
							<Components.Carousel
								slidesTotal={revenueData.allTimeRevenue.length}
							>
								{revenueData.allTimeRevenue.map(({ year, revenue }, index) => (
									<Slide
										key={index}
										index={index}
										className="max-w-full 
										overflow-hidden"
									>
										<h1
											className="
											text-3xl 
											font-medium 
											tracking-tighter 
											text-center 
											"
										>
											Rs.&nbsp;
											{revenue.reduce((a, b) => a + b).toLocaleString()}
										</h1>
										<h2
											className="text-darker 
											mt-1 
											text-center
											text-lg
											"
										>
											{year}
										</h2>
									</Slide>
								))}
							</Components.Carousel>
						)}
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
						min-h-[220px]
						sm:min-w-[500px] flex-[3]
						p-5 m-2
						bg-white 
						rounded-md
						overflow-hidden
						flex flex-col
                    	duration-150 ease-in-out
						"
				>
					{/* heading */}
					<div className="flex items-center justify-between px-2">
						<div className="flex items-center">
							<div
								className="
								h-6 w-6 
								flex items-center justify-center
								rounded-full
								bg-[#DBF6ED 
								text-[#8DBEAD
								bg-[#dfe6ff] 
								text-main	
								"
							>
								<HiOfficeBuilding />
							</div>

							<h1 className="ml-2 text-darker">Parking Spaces</h1>
						</div>

						<button
							className="text-xs text-main hover:opacity-80"
							onClick={() => navigate("/revenue/ps")}
						>
							View Details
						</button>
					</div>

					<p className="text-dark text-sm ml-10">Top 3 parking spaces</p>

					{/* data */}
					<div className="m-auto mb-0 w-[95%]">
						{revenueData.top3ParkingSpaces.map(({ ps, revenue }, index) => (
							<div
								key={index}
								className="
								flex items-center flex-wrap
								text-sm 
								bg-bg1
								border
								p-4 sm:py-0.5
								mt-2
								rounded
								hover:opacity-80 duration-300 ease-in-out
								"
							>
								<span className="h-3 w-3 bg-main rounded-full max-sm:hidden" />
								<p className="ml-2">{ps}</p>
								<p className="ml-auto pl-2">Rs. {revenue.toLocaleString()}</p>
							</div>
						))}
					</div>
				</div>
			</div>

			{/* BOTTOM CARDS ROW */}
			<div className="BOTTOM-CARDS flex flex-col md:flex-row md:items-stretch md:justify-between md:flex-wrap md:mt-2 flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[380px] sm:min-h-[480px] 
					sm:min-w-[500px] 
					flex-[3] 
					max-sm:max-w-full 
					rounded-md
                    p-5 m-2
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    overflow-hidden
                    "
				>
					{/* heading */}
					<div className="pl-2 pb-7 w-full">
						<div
							className="
							w-full
							px-2 
							flex 
							items-center justify-between 
							flex-wrap
							"
						>
							<div className="flex items-center justify-between">
								<h1 className="text-xl">Revenues</h1>
							</div>

							<Select
								className="text-sm z-50"
								styles={settings.selectStyles}
								options={[
									{ value: "all-time", label: "All Time" },
									{ value: "yearly", label: "Yearly" },
								]}
								defaultValue={{ value: "all-time", label: "All Time" }}
								onChange={(e) => setTrendType(e.value)}
							/>
						</div>

						<p className="text-dark text-sm pl-2">
							{trendType === "all-time"
								? "Air Space total revenue trends"
								: "Air Space yearly revenue trends"}
						</p>
					</div>

					{/* data */}
					<div className="w-full flex-1 overflow-hidden">
						{trendType === "all-time" ? (
							<Chart
								options={settings.yearlyTrendGraph.options}
								series={[
									{
										name: "Years",
										data: revenueData.allTimeRevenue.map((x) =>
											x.revenue.reduce((sum, cur) => sum + cur)
										),
									},
								]}
								type="area"
								height="100%"
								width="100%"
							/>
						) : (
							<Components.Carousel
								slidesTotal={revenueData.allTimeRevenue.length}
							>
								{revenueData.allTimeRevenue.map(({ year, revenue }, index) => (
									<Slide
										index={index}
										className="w-full bg-transparent
										overflow-hidden"
									>
										<div className="w-full flex flex-col">
											<h1 className="border-2 rounded w-fit px-2 font-medium text-darker">
												{year}
											</h1>
											<Chart
												options={settings.yearlyTrendGraph.options}
												series={[
													{
														name: "Months",
														data: revenue,
													},
												]}
												type="area"
												height="350px"
												width="100%"
											/>
										</div>
									</Slide>
								))}
							</Components.Carousel>
						)}
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[380px] sm:min-h-[480px] 
					sm:min-w-[400px] 
					flex-[2] 
					max-sm:max-w-full 
                    p-5 m-2
					bg-white 
					rounded-md
					flex flex-col
		            duration-150 ease-in-out
					"
				>
					{/* heading */}
					<div className="px-2 pb-2 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Cities</h1>
						</div>
						<p className="text-dark text-sm">Per city revenue details</p>
					</div>

					{/* data */}
					<div className="w-full flex-1 overflow-hidden">
						<Chart
							options={settings.cityTrendGraph.options}
							series={settings.cityTrendGraph.series}
							type="bar"
							height="100%"
							width="100%"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
